import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-save-query-dialog',
  templateUrl: './save-query-dialog.component.html',
  styleUrls: ['./save-query-dialog.component.scss']
})
export class SaveQueryDialogComponent implements OnInit {
  queryTitle: any;

  constructor(public dialogRef: MatDialogRef<SaveQueryDialogComponent>) {
  }

  ngOnInit(): void {
  }

  cancel() {
    this.close();
  }

  save() {
    this.close(this.queryTitle);
  }

  close(title?: string) {
    this.dialogRef.close(title);
  }
}
